import { Components } from '@mui/material/styles';
import { Theme } from '@mui/material';

export const flowBackdrop: Components<Theme>['MuiBackdrop'] = {
  styleOverrides: {
    root: ({ theme }) => ({
      backgroundColor: theme.palette.mode === 'dark' ? 'rgba(0,0,0,0.6)' : theme.palette.transparent.backdrop,
      backdropFilter: 'blur(4px)',
    }),
    invisible: {
      backgroundColor: 'transparent',
      backdropFilter: 'none',
    },
  },
};
